import { Cookies } from 'react-cookie';

import { CompanyPestResponse, ClientFormValuesPestCompany } from './types';

import { axiosInterceptorForMultipartFromData } from 'api/interceptor/axiosClient';

export const createCompanyPest = async ({
  client,
}: {
  client: ClientFormValuesPestCompany;
}): Promise<CompanyPestResponse> => {
  const fd = new FormData();
  fd.append('name', client.name);
  fd.append('ownership_form', client.ownership_form);
  fd.append('description', client.description || '');
  fd.append('EDRPOU', client.EDRPOU || '');
  fd.append('zip_code', client.zip_code || '');
  fd.append('country', String(client.country));
  fd.append('city_text', client.city_text || '');
  fd.append('street', client.street);
  fd.append('building_no', client.building_no);
  fd.append('apartment_no', client.apartment_no || '');

  if (client.logo instanceof File) {
    fd.append('logo', client.logo);
  }

  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptorForMultipartFromData.post('/service-provider-companies/', fd, {
    headers: {
      Authorization: token,
    },
  });

  return data.data as CompanyPestResponse;
};
